module.exports = __webpack_public_path__ + "static/chris-biscardi-f9f30c09854c4141666e237127673f09.jpeg";